// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"61aef6ca","46":"24f538ab","157":"e8254b27","532":"aca05b4a","563":"c03bd44d","810":"21017ce6"}[chunkId] + ".js";
};